module.exports = __webpack_public_path__ + "media/npc_dota_hero_chaos_knight.a09214d1.webm";